import { getFunctions, httpsCallable } from 'firebase/functions';

type CreateCheckoutSessionInput = {
  successUrl: string;
  cancelUrl: string;
};

type CreateCheckoutSessionResult = {
  sessionId: string;
  url: string;
};

type CreatePortalSessionInput = {
  returnUrl: string;
};

type CreatePortalSessionResult = {
  url: string;
};

const functions = getFunctions();

/**
 * Stripe checkout service for frontend
 */
export const stripeService = {
  /**
   * Create a Stripe Checkout session and redirect to payment
   */
  async createCheckoutSession(): Promise<void> {
    const createSession = httpsCallable<
      CreateCheckoutSessionInput,
      CreateCheckoutSessionResult
    >(functions, 'createCheckoutSession');

    const { data } = await createSession({
      successUrl: `${window.location.origin}/dashboard?upgrade=success`,
      cancelUrl: `${window.location.origin}/dashboard?upgrade=canceled`,
    });

    // Redirect to Stripe Checkout
    window.location.href = data.url;
  },

  /**
   * Open Stripe Customer Portal for subscription management
   */
  async openCustomerPortal(): Promise<void> {
    const createPortal = httpsCallable<
      CreatePortalSessionInput,
      CreatePortalSessionResult
    >(functions, 'createPortalSession');

    const { data } = await createPortal({
      returnUrl: `${window.location.origin}/dashboard`,
    });

    // Redirect to Stripe Customer Portal
    window.location.href = data.url;
  },
};
